[
  {
    "id": "miecz-rycerski",
    "name": "Miecz Rycerski",
    "description": "Wyważona, niezawodna klinga.",
    "slot": "weapon",
    "classes": [
      "straznik"
    ],
    "visual": "item:miecz-rycerski",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.1
      }
    ]
  },
  {
    "id": "dwureczny-miecz",
    "name": "Dwuręczny Miecz",
    "description": "Ciężki, ale każdy cios się liczy.",
    "slot": "weapon",
    "classes": [
      "straznik"
    ],
    "twoHanded": true,
    "visual": "item:dwureczny-miecz",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.18
      },
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": -0.03
      }
    ]
  },
  {
    "id": "topor-bojowy",
    "name": "Topór Bojowy",
    "description": "Rąbie zbroje i kości.",
    "slot": "weapon",
    "classes": [
      "barbarzynca"
    ],
    "visual": "item:topor-bojowy",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.08
      },
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.02
      }
    ]
  },
  {
    "id": "wielki-topor",
    "name": "Wielki Topór",
    "description": "Zamach, po którym nikt nie wstaje.",
    "slot": "weapon",
    "classes": [
      "barbarzynca"
    ],
    "twoHanded": true,
    "visual": "item:wielki-topor",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.15
      },
      {
        "stat": "area",
        "op": "mul",
        "value": 0.08,
        "tags": [
          "area"
        ]
      }
    ]
  },
  {
    "id": "runiczny-topor",
    "name": "Runiczny Topór",
    "description": "Runy na ostrzu jarzą się, gdy w pobliżu czai się nieumarły.",
    "slot": "weapon",
    "classes": [
      "barbarzynca"
    ],
    "twoHanded": true,
    "visual": "item:runiczny-topor",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.16
      },
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.03
      },
      {
        "stat": "area",
        "op": "mul",
        "value": 0.06,
        "tags": [
          "area"
        ]
      }
    ]
  },
  {
    "id": "kusza",
    "name": "Kusza",
    "description": "Lekka, szybka w przeładowaniu.",
    "slot": "weapon",
    "classes": [
      "tropiciel"
    ],
    "visual": "item:kusza",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.08,
        "tags": [
          "projectile"
        ]
      },
      {
        "stat": "projectileSpeed",
        "op": "mul",
        "value": 0.1,
        "tags": [
          "projectile"
        ]
      }
    ]
  },
  {
    "id": "ciezka-kusza",
    "name": "Ciężka Kusza",
    "description": "Bełt przechodzi na wylot.",
    "slot": "weapon",
    "classes": [
      "tropiciel"
    ],
    "twoHanded": true,
    "visual": "item:ciezka-kusza",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.14,
        "tags": [
          "projectile"
        ]
      },
      {
        "stat": "pierce",
        "op": "add",
        "value": 0.5,
        "tags": [
          "projectile"
        ]
      }
    ]
  },
  {
    "id": "kostna-klinga",
    "name": "Kostna Klinga",
    "description": "Wyrwana z rąk pokonanego szkieleta.",
    "slot": "weapon",
    "classes": [
      "straznik",
      "barbarzynca"
    ],
    "visual": "item:kostna-klinga",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.09
      },
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.02
      }
    ]
  },
  {
    "id": "sztylet",
    "name": "Sztylet",
    "description": "Krótki i bezlitosny.",
    "slot": "weapon",
    "classes": [
      "tropiciel"
    ],
    "visual": "item:sztylet",
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.04
      },
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.03
      }
    ]
  },
  {
    "id": "rozdzka",
    "name": "Różdżka",
    "description": "Skupia energię w jednym punkcie.",
    "slot": "weapon",
    "classes": [
      "arkanista"
    ],
    "visual": "item:rozdzka",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.07
      },
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.04
      }
    ]
  },
  {
    "id": "kostur",
    "name": "Kostur",
    "description": "Stary kij pełen mocy.",
    "slot": "weapon",
    "classes": [
      "arkanista"
    ],
    "twoHanded": true,
    "visual": "item:kostur",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.12
      },
      {
        "stat": "area",
        "op": "mul",
        "value": 0.1
      }
    ]
  },
  {
    "id": "krysztalowy-kostur",
    "name": "Kryształowy Kostur",
    "description": "Kryształ w koronie gałęzi szepcze, gdy rośnie w nim moc.",
    "slot": "weapon",
    "classes": [
      "arkanista"
    ],
    "twoHanded": true,
    "visual": "item:krysztalowy-kostur",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.14
      },
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.05
      },
      {
        "stat": "area",
        "op": "mul",
        "value": 0.08
      }
    ]
  },
  {
    "id": "tarcza-okragla",
    "name": "Okrągła Tarcza",
    "description": "Prosta osłona z dębowych desek.",
    "slot": "offhand",
    "classes": [
      "straznik"
    ],
    "visual": "item:tarcza-okragla",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 4
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 10
      }
    ]
  },
  {
    "id": "tarcza-z-herbem",
    "name": "Tarcza z Herbem",
    "description": "Znak zakonu, który dawno upadł.",
    "slot": "offhand",
    "classes": [
      "straznik"
    ],
    "visual": "item:tarcza-z-herbem",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 6
      }
    ]
  },
  {
    "id": "tarcza-kolczasta",
    "name": "Kolczasta Tarcza",
    "description": "Broni i rani jednocześnie.",
    "slot": "offhand",
    "classes": [
      "straznik"
    ],
    "visual": "item:tarcza-kolczasta",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 3
      },
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.05
      }
    ]
  },
  {
    "id": "pawez",
    "name": "Pawęż",
    "description": "Ściana, za którą da się przeżyć.",
    "slot": "offhand",
    "classes": [
      "straznik"
    ],
    "visual": "item:pawez",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 8
      },
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": -0.03
      }
    ]
  },
  {
    "id": "tarcza-barbarzyncy",
    "name": "Tarcza Barbarzyńcy",
    "description": "Obita skórą i pełna śladów po zębach.",
    "slot": "offhand",
    "classes": [
      "barbarzynca"
    ],
    "visual": "item:tarcza-barbarzyncy",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 20
      }
    ]
  },
  {
    "id": "topor-poreczny",
    "name": "Toporek Poręczny",
    "description": "Drugi topór nigdy nie zaszkodzi.",
    "slot": "offhand",
    "classes": [
      "barbarzynca"
    ],
    "visual": "item:topor-poreczny",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.05
      },
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.02
      }
    ]
  },
  {
    "id": "krotki-miecz",
    "name": "Krótki Miecz",
    "description": "Do lewej ręki, na wszelki wypadek.",
    "slot": "offhand",
    "classes": [
      "straznik"
    ],
    "visual": "item:krotki-miecz",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.07
      }
    ]
  },
  {
    "id": "noz-do-rzucania",
    "name": "Nóż do Rzucania",
    "description": "Zawsze pod ręką.",
    "slot": "offhand",
    "classes": [
      "tropiciel"
    ],
    "visual": "item:noz-do-rzucania",
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.05
      }
    ]
  },
  {
    "id": "ksiega-zaklec",
    "name": "Księga Zaklęć",
    "description": "Zamknięta, ale słychać szepty.",
    "slot": "offhand",
    "classes": [
      "arkanista"
    ],
    "visual": "item:ksiega-zaklec",
    "modifiers": [
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.06
      }
    ]
  },
  {
    "id": "otwarta-ksiega",
    "name": "Otwarta Księga",
    "description": "Strony same się przewracają.",
    "slot": "offhand",
    "classes": [
      "arkanista"
    ],
    "visual": "item:otwarta-ksiega",
    "modifiers": [
      {
        "stat": "area",
        "op": "mul",
        "value": 0.1
      }
    ]
  },
  {
    "id": "helm-rycerski",
    "name": "Hełm Rycerski",
    "description": "Zamknięta przyłbica.",
    "slot": "head",
    "classes": [
      "straznik"
    ],
    "visual": "item:helm-rycerski",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 5
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 15
      }
    ]
  },
  {
    "id": "futrzana-czapa",
    "name": "Futrzana Czapa",
    "description": "Ciepła, groźna i trochę śmierdzi.",
    "slot": "head",
    "classes": [
      "barbarzynca"
    ],
    "visual": "item:futrzana-czapa",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 25
      },
      {
        "stat": "regen",
        "op": "add",
        "value": 0.2
      }
    ]
  },
  {
    "id": "spiczasty-kapelusz",
    "name": "Spiczasty Kapelusz",
    "description": "Im wyższy, tym mądrzejszy.",
    "slot": "head",
    "classes": [
      "arkanista"
    ],
    "visual": "item:spiczasty-kapelusz",
    "modifiers": [
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.05
      },
      {
        "stat": "pickupRadius",
        "op": "mul",
        "value": 0.15
      }
    ]
  },
  {
    "id": "kaptur-zwiadowcy",
    "name": "Kaptur Zwiadowcy",
    "description": "Cień pod kapturem skrywa spojrzenie.",
    "slot": "head",
    "classes": [
      "tropiciel"
    ],
    "visual": "item:kaptur-zwiadowcy",
    "look": {
      "color": "#3f4a33",
      "material": "cloth"
    },
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.03
      },
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.03
      }
    ]
  },
  {
    "id": "kapelusz-nekromanty",
    "name": "Kapelusz Nekromanty",
    "description": "Zdjęty z głowy, która już go nie potrzebowała.",
    "slot": "head",
    "classes": [
      "arkanista"
    ],
    "visual": "item:kapelusz-nekromanty",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.06
      },
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.03
      }
    ]
  },
  {
    "id": "peleryna-rycerska",
    "name": "Peleryna Rycerska",
    "description": "Gruba wełna w barwach zakonu.",
    "slot": "back",
    "classes": [
      "straznik"
    ],
    "visual": "item:peleryna-rycerska",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 3
      }
    ]
  },
  {
    "id": "skora-wilka",
    "name": "Skóra Wilka",
    "description": "Trofeum z pierwszego polowania.",
    "slot": "back",
    "classes": [
      "barbarzynca"
    ],
    "visual": "item:skora-wilka",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 15
      }
    ]
  },
  {
    "id": "plaszcz-cienia",
    "name": "Płaszcz Cienia",
    "description": "Lekki jak dym.",
    "slot": "back",
    "classes": [
      "tropiciel"
    ],
    "visual": "item:plaszcz-cienia",
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.05
      }
    ]
  },
  {
    "id": "plaszcz-gwiazd",
    "name": "Płaszcz Gwiazd",
    "description": "Haftowany srebrną nicią.",
    "slot": "back",
    "classes": [
      "arkanista"
    ],
    "visual": "item:plaszcz-gwiazd",
    "modifiers": [
      {
        "stat": "regen",
        "op": "add",
        "value": 0.2
      },
      {
        "stat": "pickupRadius",
        "op": "mul",
        "value": 0.1
      }
    ]
  },
  {
    "id": "postrzepiona-peleryna",
    "name": "Postrzępiona Peleryna",
    "description": "Pamięta niejedną ucieczkę.",
    "slot": "back",
    "classes": [
      "tropiciel"
    ],
    "visual": "item:postrzepiona-peleryna",
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.04
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 10
      }
    ]
  },
  {
    "id": "napiersnik-rycerski",
    "name": "Napierśnik Rycerski",
    "description": "Lśniąca płyta, która przyjęła niejeden cios.",
    "slot": "chest",
    "classes": [
      "straznik"
    ],
    "visual": "armor:napiersnik-rycerski",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 6
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 15
      }
    ],
    "look": {
      "color": "#9aa3ad",
      "material": "metal",
      "trim": "#c9a24a"
    }
  },
  {
    "id": "kolczuga-straznicy",
    "name": "Kolczuga Strażnicy",
    "description": "Tysiące stalowych ogniw splecionych na zamówienie straży.",
    "slot": "chest",
    "classes": [
      "straznik"
    ],
    "visual": "armor:kolczuga-straznicy",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 4
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 20
      }
    ],
    "look": {
      "color": "#7d858c",
      "material": "metal"
    }
  },
  {
    "id": "brygantyna-herbowa",
    "name": "Brygantyna Herbowa",
    "description": "Płytki nitowane pod sukiennym wierzchem w barwach straży.",
    "slot": "chest",
    "classes": [
      "straznik"
    ],
    "visual": "armor:brygantyna-herbowa",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 5
      },
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.03
      }
    ],
    "look": {
      "color": "#34497a",
      "material": "leather",
      "trim": "#c9a24a"
    }
  },
  {
    "id": "nagolenniki-plytowe",
    "name": "Nagolenniki Płytowe",
    "description": "Ciężkie, ale nogi wytrzymają.",
    "slot": "legs",
    "classes": [
      "straznik"
    ],
    "visual": "armor:nagolenniki-plytowe",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 4
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 10
      }
    ],
    "look": {
      "color": "#9aa3ad",
      "material": "metal"
    }
  },
  {
    "id": "nogawice-kolcze",
    "name": "Nogawice Kolcze",
    "description": "Kolczuga od biodra po kostkę.",
    "slot": "legs",
    "classes": [
      "straznik"
    ],
    "visual": "armor:nogawice-kolcze",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 3
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 12
      }
    ],
    "look": {
      "color": "#7d858c",
      "material": "metal"
    }
  },
  {
    "id": "spodnie-herbowe",
    "name": "Spodnie Herbowe",
    "description": "Lekkie sukno w barwach straży.",
    "slot": "legs",
    "classes": [
      "straznik"
    ],
    "visual": "armor:spodnie-herbowe",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 2
      },
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.03
      }
    ],
    "look": {
      "color": "#2f3f66",
      "material": "cloth",
      "trim": "#c9a24a"
    }
  },
  {
    "id": "rekawice-plytowe",
    "name": "Rękawice Płytowe",
    "description": "Stal na każdym palcu.",
    "slot": "hands",
    "classes": [
      "straznik"
    ],
    "visual": "armor:rekawice-plytowe",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 3
      },
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.03
      }
    ],
    "look": {
      "color": "#9aa3ad",
      "material": "metal"
    }
  },
  {
    "id": "karwasze-straznika",
    "name": "Karwasze Strażnika",
    "description": "Twarda skóra chroni przedramiona przy zamachu.",
    "slot": "hands",
    "classes": [
      "straznik"
    ],
    "visual": "armor:karwasze-straznika",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 2
      },
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.02
      }
    ],
    "look": {
      "color": "#5a4030",
      "material": "leather",
      "trim": "#c9a24a"
    }
  },
  {
    "id": "rekawice-kolcze",
    "name": "Rękawice Kolcze",
    "description": "Giętkie ogniwa, pewny chwyt.",
    "slot": "hands",
    "classes": [
      "straznik"
    ],
    "visual": "armor:rekawice-kolcze",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 2
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 10
      }
    ],
    "look": {
      "color": "#7d858c",
      "material": "metal"
    }
  },
  {
    "id": "trzewiki-plytowe",
    "name": "Trzewiki Płytowe",
    "description": "Stalowe noski, które dźwięczą na kamieniach.",
    "slot": "feet",
    "classes": [
      "straznik"
    ],
    "visual": "armor:trzewiki-plytowe",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 3
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 5
      }
    ],
    "look": {
      "color": "#9aa3ad",
      "material": "metal"
    }
  },
  {
    "id": "buty-marszowe",
    "name": "Buty Marszowe",
    "description": "Przeszły więcej mil niż ich właściciel.",
    "slot": "feet",
    "classes": [
      "straznik"
    ],
    "visual": "armor:buty-marszowe",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 1
      },
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.03
      }
    ],
    "look": {
      "color": "#5a4030",
      "material": "leather"
    }
  },
  {
    "id": "sabatony-herbowe",
    "name": "Sabatony Herbowe",
    "description": "Stalowe buty ze złotym okuciem.",
    "slot": "feet",
    "classes": [
      "straznik"
    ],
    "visual": "armor:sabatony-herbowe",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 2
      },
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.02
      }
    ],
    "look": {
      "color": "#9aa3ad",
      "material": "metal",
      "trim": "#c9a24a"
    }
  },
  {
    "id": "kaftan-niedzwiedzi",
    "name": "Kaftan z Niedźwiedziej Skóry",
    "description": "Ciepły, ciężki i pachnący lasem.",
    "slot": "chest",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:kaftan-niedzwiedzi",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 25
      },
      {
        "stat": "regen",
        "op": "add",
        "value": 0.1
      }
    ],
    "look": {
      "color": "#5b4330",
      "material": "fur"
    }
  },
  {
    "id": "uprzaz-wojownika",
    "name": "Uprząż Wojownika",
    "description": "Rzemienie i klamry — reszta to mięśnie.",
    "slot": "chest",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:uprzaz-wojownika",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.05
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 10
      }
    ],
    "look": {
      "color": "#6b4a2e",
      "material": "leather",
      "trim": "#8a8f96"
    }
  },
  {
    "id": "futro-watahy",
    "name": "Futro Watahy",
    "description": "Szare futro zdarte z przywódcy stada.",
    "slot": "chest",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:futro-watahy",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 20
      },
      {
        "stat": "armor",
        "op": "add",
        "value": 2
      }
    ],
    "look": {
      "color": "#8a8780",
      "material": "fur"
    }
  },
  {
    "id": "futrzane-nogawice",
    "name": "Futrzane Nogawice",
    "description": "Kudłate i ciepłe.",
    "slot": "legs",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:futrzane-nogawice",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 15
      }
    ],
    "look": {
      "color": "#5b4330",
      "material": "fur"
    }
  },
  {
    "id": "skorzane-portki",
    "name": "Skórzane Portki",
    "description": "Wygodne do biegu przez krzaki.",
    "slot": "legs",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:skorzane-portki",
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.03
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 5
      }
    ],
    "look": {
      "color": "#4e3524",
      "material": "leather"
    }
  },
  {
    "id": "przepaska-wodza",
    "name": "Przepaska Wodza",
    "description": "Czerwień, którą widać z drugiego końca pola bitwy.",
    "slot": "legs",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:przepaska-wodza",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.04
      }
    ],
    "look": {
      "color": "#7a2a1e",
      "material": "cloth",
      "trim": "#c9a24a"
    }
  },
  {
    "id": "owijki-piesci",
    "name": "Owijki Pięści",
    "description": "Lniane pasy zaciśnięte na kłykciach.",
    "slot": "hands",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:owijki-piesci",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.04
      }
    ],
    "look": {
      "color": "#b9a586",
      "material": "cloth"
    }
  },
  {
    "id": "karwasze-z-kosci",
    "name": "Karwasze z Kości",
    "description": "Rzeźbione kości przytroczone rzemieniem.",
    "slot": "hands",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:karwasze-z-kosci",
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.02
      },
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.02
      }
    ],
    "look": {
      "color": "#6b4a2e",
      "material": "leather",
      "trim": "#e8dcc0"
    }
  },
  {
    "id": "rekawice-futrzane",
    "name": "Rękawice Futrzane",
    "description": "Dłonie ciepłe nawet w zamieci.",
    "slot": "hands",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:rekawice-futrzane",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 10
      },
      {
        "stat": "regen",
        "op": "add",
        "value": 0.1
      }
    ],
    "look": {
      "color": "#5b4330",
      "material": "fur"
    }
  },
  {
    "id": "futrzane-buty",
    "name": "Futrzane Buty",
    "description": "Miękkie podeszwy, kudłate cholewy.",
    "slot": "feet",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:futrzane-buty",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 10
      },
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.02
      }
    ],
    "look": {
      "color": "#5b4330",
      "material": "fur"
    }
  },
  {
    "id": "sandaly-wedrowca",
    "name": "Sandały Wędrowca",
    "description": "Lekkie i przewiewne.",
    "slot": "feet",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:sandaly-wedrowca",
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.04
      }
    ],
    "look": {
      "color": "#6b4a2e",
      "material": "leather"
    }
  },
  {
    "id": "okute-buciory",
    "name": "Okute Buciory",
    "description": "Kopniak, który przewraca szkieleta.",
    "slot": "feet",
    "classes": [
      "barbarzynca"
    ],
    "visual": "armor:okute-buciory",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 2
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 5
      }
    ],
    "look": {
      "color": "#4e3524",
      "material": "leather",
      "trim": "#8a8f96"
    }
  },
  {
    "id": "szata-adepta",
    "name": "Szata Adepta",
    "description": "Pierwsza szata każdego ucznia magii.",
    "slot": "chest",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:szata-adepta",
    "modifiers": [
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.04
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 10
      }
    ],
    "look": {
      "color": "#2d3f6e",
      "material": "cloth",
      "trim": "#c9a24a"
    }
  },
  {
    "id": "szata-gwiezdna",
    "name": "Szata Gwiezdna",
    "description": "Haft układa się w nieznane gwiazdozbiory.",
    "slot": "chest",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:szata-gwiezdna",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.05
      }
    ],
    "look": {
      "color": "#1f2547",
      "material": "cloth",
      "trim": "#b8d4ff"
    }
  },
  {
    "id": "oponcza-zaru",
    "name": "Opończa Żaru",
    "description": "Brzegi tlą się, ale nigdy nie płoną.",
    "slot": "chest",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:oponcza-zaru",
    "modifiers": [
      {
        "stat": "area",
        "op": "mul",
        "value": 0.06
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 5
      }
    ],
    "look": {
      "color": "#6e2a1e",
      "material": "cloth",
      "trim": "#e8a040"
    }
  },
  {
    "id": "spodnie-adepta",
    "name": "Spodnie Adepta",
    "description": "Proste i wygodne do długich studiów.",
    "slot": "legs",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:spodnie-adepta",
    "modifiers": [
      {
        "stat": "pickupRadius",
        "op": "mul",
        "value": 0.1
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 5
      }
    ],
    "look": {
      "color": "#2d3f6e",
      "material": "cloth"
    }
  },
  {
    "id": "szarawary-medrca",
    "name": "Szarawary Mędrca",
    "description": "Szerokie nogawice, wąskie myśli — tak mówią złośliwi.",
    "slot": "legs",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:szarawary-medrca",
    "modifiers": [
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.03
      }
    ],
    "look": {
      "color": "#4a3a5e",
      "material": "cloth"
    }
  },
  {
    "id": "nogawice-runiczne",
    "name": "Nogawice Runiczne",
    "description": "Runy na szwach świecą przy każdym zaklęciu.",
    "slot": "legs",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:nogawice-runiczne",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.03
      }
    ],
    "look": {
      "color": "#2a2a3a",
      "material": "cloth",
      "trim": "#8fd3ff"
    }
  },
  {
    "id": "rekawiczki-zaklinacza",
    "name": "Rękawiczki Zaklinacza",
    "description": "Cienki jedwab, nic nie przeszkadza w gestach.",
    "slot": "hands",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:rekawiczki-zaklinacza",
    "modifiers": [
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.03
      }
    ],
    "look": {
      "color": "#3a2f4f",
      "material": "cloth"
    }
  },
  {
    "id": "karwasze-run",
    "name": "Karwasze Run",
    "description": "Skóra wyryta znakami mocy.",
    "slot": "hands",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:karwasze-run",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.04
      }
    ],
    "look": {
      "color": "#3a3040",
      "material": "leather",
      "trim": "#8fd3ff"
    }
  },
  {
    "id": "mitenki-iskier",
    "name": "Mitenki Iskier",
    "description": "Palce wolne, a iskry same skaczą.",
    "slot": "hands",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:mitenki-iskier",
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.02
      }
    ],
    "look": {
      "color": "#5a4a6a",
      "material": "cloth"
    }
  },
  {
    "id": "miekkie-trzewiki",
    "name": "Miękkie Trzewiki",
    "description": "Ciche kroki w bibliotece i na pustkowiu.",
    "slot": "feet",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:miekkie-trzewiki",
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.03
      }
    ],
    "look": {
      "color": "#3a2f4f",
      "material": "cloth"
    }
  },
  {
    "id": "sandaly-pielgrzyma",
    "name": "Sandały Pielgrzyma",
    "description": "Zdarte na niejednej drodze do świątyni.",
    "slot": "feet",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:sandaly-pielgrzyma",
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.02
      },
      {
        "stat": "regen",
        "op": "add",
        "value": 0.1
      }
    ],
    "look": {
      "color": "#6b4a2e",
      "material": "leather"
    }
  },
  {
    "id": "buty-mgly",
    "name": "Buty Mgły",
    "description": "Ślady znikają, zanim opadnie kurz.",
    "slot": "feet",
    "classes": [
      "arkanista"
    ],
    "visual": "armor:buty-mgly",
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.04
      }
    ],
    "look": {
      "color": "#6a7a8a",
      "material": "cloth"
    }
  },
  {
    "id": "kurta-zwiadowcy",
    "name": "Kurta Zwiadowcy",
    "description": "Zieleń lasu, cicha jak sowa.",
    "slot": "chest",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:kurta-zwiadowcy",
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.03
      },
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.02
      }
    ],
    "look": {
      "color": "#4a5a32",
      "material": "leather"
    }
  },
  {
    "id": "kaftan-lowcy",
    "name": "Kaftan Łowcy",
    "description": "Gruba skóra z kieszeniami na bełty.",
    "slot": "chest",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:kaftan-lowcy",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.04
      },
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 10
      }
    ],
    "look": {
      "color": "#5a3e28",
      "material": "leather"
    }
  },
  {
    "id": "pancerz-z-lusek",
    "name": "Pancerz z Łusek",
    "description": "Łuski nachodzą na siebie jak u jaszczura.",
    "slot": "chest",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:pancerz-z-lusek",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 3
      },
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.02
      }
    ],
    "look": {
      "color": "#3e4a3a",
      "material": "leather",
      "trim": "#8a8f96"
    }
  },
  {
    "id": "spodnie-tropiciela",
    "name": "Spodnie Tropiciela",
    "description": "Skóra natłuszczona przeciw rosie.",
    "slot": "legs",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:spodnie-tropiciela",
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.04
      }
    ],
    "look": {
      "color": "#4a3a28",
      "material": "leather"
    }
  },
  {
    "id": "nogawice-z-latami",
    "name": "Nogawice z Łatami",
    "description": "Każda łata to inna przygoda.",
    "slot": "legs",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:nogawice-z-latami",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 10
      },
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.02
      }
    ],
    "look": {
      "color": "#5a5a3e",
      "material": "cloth"
    }
  },
  {
    "id": "ochraniacze-lowcy",
    "name": "Ochraniacze Łowcy",
    "description": "Usztywnione kolana i uda.",
    "slot": "legs",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:ochraniacze-lowcy",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 2
      },
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.01
      }
    ],
    "look": {
      "color": "#5a3e28",
      "material": "leather",
      "trim": "#8a8f96"
    }
  },
  {
    "id": "rekawice-lucznicze",
    "name": "Rękawice Łucznicze",
    "description": "Wzmocnione palce do napinania cięciwy.",
    "slot": "hands",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:rekawice-lucznicze",
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.03
      }
    ],
    "look": {
      "color": "#5a3e28",
      "material": "leather"
    }
  },
  {
    "id": "karwasze-strzelca",
    "name": "Karwasze Strzelca",
    "description": "Chronią przedramię przed cięciwą.",
    "slot": "hands",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:karwasze-strzelca",
    "modifiers": [
      {
        "stat": "projectileSpeed",
        "op": "mul",
        "value": 0.08
      },
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.02
      }
    ],
    "look": {
      "color": "#3e3226",
      "material": "leather",
      "trim": "#b0a080"
    }
  },
  {
    "id": "rekawice-bez-palcow",
    "name": "Rękawice bez Palców",
    "description": "Pewny chwyt, szybki strzał.",
    "slot": "hands",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:rekawice-bez-palcow",
    "modifiers": [
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.03
      }
    ],
    "look": {
      "color": "#4a3a28",
      "material": "leather"
    }
  },
  {
    "id": "ciche-buty",
    "name": "Ciche Buty",
    "description": "Miękka podeszwa, żadnego skrzypnięcia.",
    "slot": "feet",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:ciche-buty",
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.05
      }
    ],
    "look": {
      "color": "#3a3026",
      "material": "leather"
    }
  },
  {
    "id": "buty-bagienne",
    "name": "Buty Bagienne",
    "description": "Wysokie i szczelne, błoto im niestraszne.",
    "slot": "feet",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:buty-bagienne",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 10
      },
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.02
      }
    ],
    "look": {
      "color": "#4a4a32",
      "material": "leather"
    }
  },
  {
    "id": "wysokie-cholewy",
    "name": "Wysokie Cholewy",
    "description": "Sznurowane aż pod kolano.",
    "slot": "feet",
    "classes": [
      "tropiciel"
    ],
    "visual": "armor:wysokie-cholewy",
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.03
      },
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.01
      }
    ],
    "look": {
      "color": "#5a3e28",
      "material": "leather"
    }
  }
]
